import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from './organization-account.regions.reducer';
import {Region} from '../../../services/api/account/regions/region.model';

export const loadOrganizationRegionsFeatureKey = 'organizationRegions';
export const getOrganizationRegionsSelector = createFeatureSelector<State>(loadOrganizationRegionsFeatureKey);

export const getOrganizationRegions = createSelector(
    getOrganizationRegionsSelector,
    (state: State): Region[] => state.record
);

export const getOrganizationRegionsLoaded = createSelector(
    getOrganizationRegionsSelector,
    (state: State): boolean => state.loaded
);

export const getOrganizationRegionsLoading = createSelector(
    getOrganizationRegionsSelector,
    (state: State): boolean => state.loading
);

export const getOrganizationRegionsError = createSelector(
    getOrganizationRegionsSelector,
    (state: State): any => state.error
);
